const defaultRegisterState = () => {
    return {
        user: {},
        company: {},
        partner: {},
        partners: [],
        partnersPagination: [],
        formIsChanged: false,
        economicGroupIds: []
    }
}
export default {
    namespaced: true,
    state: defaultRegisterState(),
    mutations: {
        setUser(state, user) {
            Object.assign(state, { user });
        },
        setCompany(state, company) {
            Object.assign(state, { company: { ...state.company, ...company } });
        },
        setPartner(state, partner) {
            Object.assign(state, { partner: { ...state.partner, ...partner } });
        },
        resetPartner(state) {
            Object.assign(state, { partner: {} });
        },
        resetCompany(state) {
            Object.assign(state, { company: {} });
        },
        setPartners(state, partners) {
            Object.assign(state, { partners });
        },
        setPartnersPagination(state, partnersPagination) {
            Object.assign(state, { partnersPagination });
        },
        resetPartners(state) {
            Object.assign(state, { partners: [] });
        },
        resetState(state) {
            Object.assign(state, defaultRegisterState())
        },
        setFormIsChanged(state, formIsChanged) {
            Object.assign(state, { formIsChanged })
        },
        setRegisterStep(state, registerStep) {
            Object.assign(state, { company: { ...state.company, cnpj: { ...state.company.cnpj, registerStep } } })
        },
        setEconomicGroups(state, economicGroupIds) {
            Object.assign(state, { economicGroupIds })
        }
    },
    actions: {}
}